
// Generated by dayjs-nuxt-module
import dayjs from 'dayjs'
import 'dayjs/locale/id'
import relativeTime from 'dayjs/plugin/relativeTime'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import isBetween from 'dayjs/plugin/isBetween'
import updateLocale from 'dayjs/plugin/updateLocale'

dayjs.extend(relativeTime)
dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.extend(isBetween)
dayjs.extend(updateLocale)
dayjs.extend(updateLocale)
dayjs.locale('id')
dayjs.tz.setDefault('Asia/Jakarta')


dayjs.updateLocale("id")

export default dayjs
